import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AppearDirective } from './directives/appear.directive';
import { CmsPipe } from './pipes/cms.pipe';

@NgModule({
  declarations: [AppearDirective, CmsPipe],
  imports: [CommonModule],
  exports: [AppearDirective, CmsPipe],
})
export class SharedModule {}
